<template>
  <div data-app class="object-menu-container" :style="[xPosition, yPosition]">
    <v-list subheader class="pa-0">
      <v-list-item
        v-for="item in menuItems"
        :key="item.title"
        v-if="item.visible"
        :disabled="item.disabled"
        @click="executeAction(item.id)"
        style="height: 30px; min-height: 35px"
      >
        <v-icon size="15" class="mr-3">{{ item.icon }}</v-icon>

        <span class="pr-2" style="font-size: 10px">{{ item.title }}</span>
      </v-list-item>
    </v-list>

    <app-dialog-box
      :open="deleteDialog"
      :title="$t('Delete')"
      :content="deleteDialogMessage"
      :main-action-label="$t('No')"
      @mainAction="cancelDelete"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="confirmOpenSecondDialog"
      :loading="loadingDelete"
    />

    <app-dialog-box
      :open="secondDeleteDialog"
      :title="$t('Delete')"
      :content="deletecableWithClosure"
      :main-action-label="$t('No')"
      @mainAction="cancelDelete"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="confirmDelete('?deleteCluster=true')"
      :loading="loadingDelete"
    />

    <app-dialog-box
      :open="joinCablesDialog"
      :title="$t('Join') + ' ' + $tc('Cable', 2)"
      :content="joinCablesDialogMessage"
      :main-action-label="$t('No')"
      @mainAction="cancelDelete"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="confirmDelete('?join_cables=true')"
      :loading="loadingDelete"
    />

    <app-dialog-box
      :open="joinPathwayWhenDeleteTP.open"
      :title="joinPathwayWhenDeleteTP.title"
      :content="joinPathwayWhenDeleteTP.content"
      :main-action-label="$t('Yes')"
      @mainAction="confirmJoinPathwayOrDeleteTP"
      :secondary-action-label="$t('No')"
      @secondaryAction="joinPathwayWhenDeleteTP.open = false"
      :loading="loadingDelete"
    />

    <dialog-delete-cable-when-delete-cluster
      :open="deleteCablesWhenDeleteClusterDialog"
      @cancel="deleteCablesWhenDeleteClusterDialog = false"
      @delete-cables-created-automatically="
        confirmDelete('?cablesToDelete=only_automatic')
      "
      @delete-all-cables="confirmDelete('?cablesToDelete=all_cables')"
      :loading="loadingDelete"
    />

  </div>
</template>

<script>
import { mapActions } from "vuex";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import _ from "lodash";
import utils from "@/utils";
import GeoJSON from "ol/format/GeoJSON";
import WKT from "ol/format/WKT";
import DialogDeleteCableWhenDeleteCluster from "@/components/Home/Content/Dialog/DialogDeleteCableWhenDeleteCluster";

export default {
  name: "HomeObjectMenu",

  components: { DialogDeleteCableWhenDeleteCluster, AppDialogBox },

  mixins: [checkPermissionsMixin],

  props: ["coordinates"],

  data() {
    return {
      deleteDialog: false,
      secondDeleteDialog: false,
      joinCablesDialog: false,
      deleteCable: {
        dialog: false,
        cable: null,
      },

      joinPathwayWhenDeleteTP: {
        open: false,
        title: "",
        content: "",
        action_type: null,
      },

      loadingDelete: false,

      /**
       * Determines whether the dialog to confirm whether
       * the user wants to delete manually created cables when deleting a cluster
       */
      deleteCablesWhenDeleteClusterDialog: false,
    };
  },

  computed: {
    menuItems() {
      return [
        {
          id: "view",
          icon: "visibility",
          title: this.$i18n.t("View"),
          visible: this.objectIsViewable,
          disabled: !this.hasPermission("show"),
        },
        {
          id: "details",
          icon: "zoom_in",
          title: this.$i18n.tc("Detail", 2),
          visible:

            this.objectIdentifiers.layerName !== "field_workorders",
          disabled: !this.hasPermission("show"),
        },
        {
          id: "edit",
          icon: "edit",
          title: this.$i18n.t("Edit"),
          visible: this.objectIsEditable,
          disabled: !this.hasPermission("update"),
        },
        {
          id: "join",
          icon: "linear_scale",
          title: this.$i18n.t("Join"),
          visible:
            this.objectIsEditable &&
            this.objectIdentifiers.endpoint === "cables",
          disabled:
            this.objectIdentifiers.endpoint === "cables" &&
            !this.hasPermission("update") &&
            !this.hasPermission("show"),
        },
        {
          id: "reverse",
          icon: "mdi-undo-variant",
          title: this.$i18n.t("ReverseDirection"),
          visible:
            this.objectIsEditable &&
            this.objectIdentifiers.endpoint === "cables",
          disabled:
            this.objectIdentifiers.endpoint === "cables" &&
            !this.hasPermission("update"),
        },
        {
          id: "activities",
          icon: "receipt_long",
          title: this.$i18n.tc("Activity", 2),
          visible: this.activitiesVisibility,

          disabled: !this.hasPermission("update"),
        },
        {
          id: "changeLog",
          icon: "history",
          title: this.$i18n.t("ChangeLog"),
          visible:
            (this.isSuperAdmin &&
              this.objectIdentifiers.layerName !== "field_workorders") ||
            (this.isAdmin &&
              this.objectIdentifiers.layerName !== "field_workorders"),
          disabled: !this.userHasFibercloudPermission("log_activity", "list"),
        },
        {
          id: "addAssetsToReservation",
          icon: "add_circle",
          title: this.$i18n.t("AddAssets"),
          visible: this.objectIdentifiers.layerName === "fc_asset_reservation",
          disabled: !this.userHasFibercloudPermission(
            "asset_reservation_object",
            "store"
          ),
        },
        {
          id: "addNetworkElementsToReservation",
          icon: "add_box",
          title: this.$i18n.t("AddNetworkElements"),
          visible: this.objectIdentifiers.layerName === "fc_asset_reservation",
          disabled: !this.userHasFibercloudPermission(
            "asset_reservation_object",
            "store"
          ),
        },
        {
          id: "splicing",
          icon: "settings_input_composite",
          title: this.$i18n.t("Splicing"),
          visible: this.objectHasSplicing,
          disabled: !this.hasPermission("show"),
        },
        {
          id: "move",
          icon: "control_camera",
          title: this.$i18n.t("Move"),
          visible: this.objectIsMovable,
          disabled: !this.hasPermission("edit_geom"),
        },
        // {
        //   id: "clone",
        //   icon: "content_copy",
        //   title: this.$i18n.t("Clone"),
        //   visible: this.objectIsCloneable,
        //   disabled: !this.hasPermission("store")
        // },
        {
          id: "redrawCluster",
          icon: "rounded_corner",
          title: this.$i18n.t("Redraw"),
          visible: this.objectIdentifiers.layerName === "fc_fiber_terminal_box",
          disabled: !(this.userHasFibercloudPermission(
            "cluster",
            "store") && this.userHasFibercloudPermission(
            "cluster",
            "destroy")) 
        },
        {
          id: "delete",
          icon: "delete",
          title: this.$i18n.t("Delete"),
          visible: this.objectIsRemovable,
          disabled: !this.hasPermission("destroy"),
        },
        {
          id: "generate_workspace",
          icon: "mdi-network-outline",
          title: this.$i18n.t("GenerateWorkspace"),
          visible: this.objectCanGenerateWorkspace,
          disabled: !this.userHasManagementPermission("workspace_store"),
        },
        {
          id: "select",
          icon: "mdi-vector-square",
          title: this.$i18n.tc("SelectObject", 2),
          visible: this.objectCanSelectObjects,
          disabled: false,
        },
      ];
    },

    objectIdentifiers() {
      return this.$store.getters.selectedObjectIdentifiers;
    },
    /**
     * determines where activity option will be available
     */
    activitiesVisibility() {
      return (
        this.userHasFibercloudPermission("field_activity", "store") &&
        this.userHasFibercloudPermission("field_activity", "show") &&
        this.objectIdentifiers.layerName !== "field_workorders" &&
        this.objectIdentifiers.type !== "Cluster" &&
        this.objectIdentifiers.layerName !== "fc_virtual"
      );
    },

    objectData() {
      return this.$store.getters.selectedObjectData;
    },

    /**
     * Finds and stores the position where the object menu should be place in the x axis.
     *
     * @returns {{right: number}|{left: string}}
     * If the click on the map is in a coordinate that allows the menu to
     * appear entirely inside the screen, the menu is placed relatively to the left side of the parent element.
     * If the menu would not be able to be entirely contained in the screen, it is placed along the right side
     * of the map.
     */
    xPosition() {
      let parentWidth = this.$parent.$refs.map.offsetWidth;
      let totalWidth = this.coordinates[0] + 100;
      if (totalWidth < parentWidth) {
        return { left: this.coordinates[0] + "px" };
      } else {
        return { right: 0 };
      }
    },

    /**
     * Finds and stores the position where the object menu should be place in the y axis.
     *
     * @returns {{top: string}|{bottom: number}}
     * If the click on the map is in a coordinate that allows the menu to
     * appear entirely inside the screen, the menu is placed relatively to the top of the parent element.
     * If the menu would not be able to be entirely contained in the screen, it is placed along the bottom of the map.
     */
    yPosition() {
      let contentHeight = this.$parent.$refs.map.offsetHeight;
      let totalHeight = this.coordinates[1] + 168;
      if (totalHeight < contentHeight) {
        return { top: +this.coordinates[1] + "px" };
      } else {
        return { bottom: 0 };
      }
    },

    joinCablesDialogMessage() {
      return this.$i18n.t("JoinCablesWhenDeleteClosure");
    },

    deletecableWithClosure() {
      return this.$i18n.t("DeleteCableWithClosure");
    },

    /**
     * Composes the Delete dialog message according to the given object type.
     * @returns {string}
     */
    deleteDialogMessage() {
      let mainMessage = "";
      if (this.deleteCable.dialog === true) {
        mainMessage += this.$i18n.t("DeleteCableWhenDeleteClosureConfirmation");
      } else {
        mainMessage += this.$i18n.t("DeleteConfirmation") + " ";

        if (
          this.objectIdentifiers.endpoint === "asset-reservations" &&
          this.objectData &&
          this.objectData.ar_external_id
        ) {
          mainMessage += this.objectData.ar_external_id;
        } else {
          mainMessage += this.objectIdentifiers.label ? this.objectIdentifiers.label : this.objectIdentifiers.id;
        }
        mainMessage += "?";

        let secondaryMessage =
          "\n \n " + this.$i18n.t("RemoveAssociatedObjectWarning");
        if (
          this.objectIdentifiers.endpoint === "technicalsites" ||
          this.objectIdentifiers.endpoint === "technicalpoints"
        ) {
          if (this.objectIdentifiers.endpoint === "technicalsites") {
            secondaryMessage += this.$i18n.tc("TechnicalLocal", 1);
          } else if (this.objectIdentifiers.endpoint === "technicalpoints") {
            secondaryMessage += this.$i18n.tc("Closure", 1);
          }
          return mainMessage + secondaryMessage + ".";
        } else return mainMessage;
      }
      return mainMessage;
    },

    /**
     * Checks if the current object is viewable or not.
     * @returns {boolean}
     */
    objectIsViewable() {
      return (
        !this.isOneOfGivenOptions(this.objectIdentifiers.layerName, [
          "fc_fiber_terminal_box",
          "fc_workspace",
          "fc_cartography",
          "fc_cartography_line",
          "fc_cartography_point",
        ]) && !this.objectIdentifiers.type.includes("base")
      );
    },

    /**
     * Checks if the current object is editable or not.
     * @returns {boolean}
     */
    objectIsEditable() {
      return this.objectIsViewable;
    },

    /**
     * Checks if the current object is movable or not.
     * @returns {boolean}
     */
    objectIsMovable() {
      return (
        !this.isOneOfGivenOptions(this.objectIdentifiers.layerName, [
          "fc_workspace",
          "fc_cable",
          "fc_fiber_terminal_box",
          "fc_cartography",
          "fc_cartography_line",
          "fc_cartography_point",
          "fc_field_cable",
          "fc_slack",
          "fc_asset_reservation",
          "fc_workpoint",
          "field_workorders",
        ]) &&
        !this.objectIdentifiers.layerName.includes("technical_local") &&
        !this.objectIdentifiers.layerName.includes("base")
      );
    },

    /**
     * Checks if the current object is editable or not.
     * @returns {boolean}
     */
    objectIsCloneable() {
      return this.isOneOfGivenOptions(this.objectIdentifiers.endpoint, [
        "technicalpoints",
        "buildings",
        "pathways",
        "fiberdistributionpoints",
        "field-cables",
        "fc_workpoint",
      ]);
    },

    /**
     * Checks if the current object is removable or not.
     * @returns {boolean}
     */
    objectIsRemovable() {
      return (
        !this.isOneOfGivenOptions(this.objectIdentifiers.layerName, [
          "fc_workspace",
          "fc_cartography",
          "fc_cartography_line",
          "fc_cartography_point",
          "fc_workpoint",
        ]) && !this.objectIdentifiers.type.includes("base")
      );
    },

    objectCanGenerateWorkspace() {
      return (
        this.objectIdentifiers.endpoint === "annotationszones" &&
        (this.objectData.anz_type === "micpl" ||
          this.objectData.anz_type === "macpl") &&
        this.objectData.anz_label &&
        this.objectData.anz_label !== ""
      );
    },

    objectCanSelectObjects() {
      return (
        this.objectIdentifiers.layerName === "fc_workspace" ||
        this.objectIdentifiers.layerName === "fc_olt_zone" ||
        this.objectIdentifiers.layerName === "fc_annotation_zone" ||
        this.objectIdentifiers.layerName === "fc_fdp_zone" ||
        this.objectIdentifiers.layerName === "fc_closure_zone" ||
        this.objectIdentifiers.layerName === "fc_fiber_terminal_box" ||
        this.objectIdentifiers.layerName === "fc_workpoint"
      );
    },

    objectHasSplicing() {
      return (
        this.objectIdentifiers.type === "Closure" ||
        this.objectIdentifiers.layerName.includes("technical_local")
      );
    },

    objectNoActivities() {
      return (
        this.objectIdentifiers.type === "Field Cable" ||
        this.objectIdentifiers.layerName === "fc_workspace" ||
        this.objectIdentifiers.layerName === "fc_workpoint" ||
        this.objectIdentifiers.layerName === "field_workorders"
      );
    },
  },

  mounted() {
    if (this.objectIdentifiers.endpoint === "annotationszones") {
      this.getObjectData(false);
    }
  },

  methods: {
    ...mapActions([
      "CLONE_OBJECTS",
      "VALIDATE_IF_OBJECT_HAS_FORM_OPENED",
      "deleteObjectByUUID",
      "fetchWorkspaceByUUID",
      "CREATE_WORKSPACE",
      "fetchObjectByUUID",
      "UPDATE_SELECTED_OBJECT_DATA",
      "SET_TOOL_ACTION",
      "SET_TOOL_OBJECT_LAYER",
      "fetchCablesInClosure",
      "fetchCablesOutClosure",
      "fetchPathwaysPassingTechPoint",
      "deleteWorkOrderByUUID",
    ]),

    executeAction(actionID) {
      switch (actionID) {
        case "delete":
          this.openDeleteDialog();
          break;
        case "generate_workspace":
          this.generateWorkspace();
          break;
        case "clone":
          this.cloneObject();
          break;
        case "splicing":
          this.openSplicing();
          break;
        case "details":
          this.openDetailForm();
          break;
        case "move":
          this.moveObject();
          break;
        case "view":
        case "edit":
          if (this.objectIdentifiers.layerName === "field_workorders") {
            this.openWorkOrders(actionID);
          } else {
            this.openForm(actionID);
          }

          break;
        case "select":
          this.selectObjectsInsideArea();
          break;
        case "addAssetsToReservation":
          this.addAssetsToReservation();
          break;
        case "addNetworkElementsToReservation":
          this.addNetworkElementsToReservation();
          break;
        case "changeLog":
          this.openChangeLogForm();
          break;
        case "activities":
          this.openActivities();
          break;
        case "join":
          this.openJoinCablesMenu();
          break;
        case "reverse":
        this.reverseCableDirection();
          break;
        case "redrawCluster":
          this.redrawCluster();
          break;
      }
    },


    isOneOfGivenOptions(actualValue, possibleValues) {
      for (let value of possibleValues) {
        if (actualValue === value) {
          return true;
        }
      }
      return false;
    },

    /**
     * Opens the MultiSelectionForm form, when the user clicks the SelectObjects button.
     *
     */

    selectObjectsInsideArea: _.debounce(function () {
      let geoJson = this.objectIdentifiers.geojson;
      let features = new GeoJSON().readFeatures(geoJson, {
        featureProjection: "EPSG:4326",
      });

      let textGeom = new WKT().writeFeature(features[0]);
      this.$emit("openMultiSelectForm", textGeom, 4326);
    }, 500),

    /**
     * Opens the object's form, when the user clicks the View button, if the user has View permission for that kind
     * of object.
     *
     * @param {string} action - type of action the user is trying to do.
     */
    openForm: _.debounce(async function (action) {
      await this.getObjectData(false);
      this.$emit("openForm", action);
    }, 500),

    /**
     * Opens the object's details form, when the user clicks the Details button, if the user has View permission for
     * that kind of object.
     */
    openDetailForm: _.debounce(async function () {
      await this.getObjectData(this.objectHasCustomData());
      this.$emit("openDetailForm");
    }, 500),

    /**
     * Starts a move action in the parent element, when the user clicks the Move button, if the user has Update
     * permission for that kind of object.
     */
    moveObject: _.debounce(function () {
      this.$emit("closeMenu", true);
      this.$emit("moveObject");
    }, 500),

    /**
     * Starts a move action in the parent element, when the user clicks the Move button, if the user has Update
     * permission for that kind of object.
     */
    addAssetsToReservation: _.debounce(async function () {
      await this.getObjectData(false);
      this.SET_TOOL_ACTION("addAssetsToReservation");
      this.SET_TOOL_OBJECT_LAYER(this.objectIdentifiers.layerName);
      this.$emit("closeMenu", true);
    }, 500),

    /**
     * Starts a move action in the parent element, when the user clicks the Move button, if the user has Update
     * permission for that kind of object.
     */
    addNetworkElementsToReservation: _.debounce(async function () {
      await this.getObjectData(false);
      this.SET_TOOL_ACTION("addNetworkElementsToReservation");
      this.SET_TOOL_OBJECT_LAYER(this.objectIdentifiers.layerName);
      this.$emit("closeMenu", true);
    }, 500),

    /**
     * Opens the Splicing tab with the selected closure's info, when the user clicks the Splicing button.
     */
    openSplicing: _.debounce(async function () {
      await this.getObjectData(false);
      this.$emit("openForm", "splicing");
    }, 500),

    /**
     * Opens the Activities tab with the selected closure's info, when the user clicks the Activities button.
     */
    openActivities: _.debounce(async function () {
      await this.getObjectData(false);
      this.$emit("openForm", "activities");
    }, 500),
    /**
     * Opens the workOrders form.
     */
    openWorkOrders: _.debounce(function (action) {
      this.$emit("openWorkorderForm", this.objectIdentifiers.uuid, action);
    }, 500),

    /**
     * Opens the object change log form, when the user clicks the Change Log button, if the user is superAdmin or admin
     */
    openChangeLogForm: _.debounce(function () {
      this.$emit("openChangeLogForm");
    }, 500),

    /**
     * Opens the join cables menu, when the user clicks the Join button
     */
    openJoinCablesMenu: _.debounce(function () {
      this.$emit("openJoinCablesMenu");
    }, 500),

    /**
     * Initiates a reverse direction cable action on the parent element when the user
     * clicks the Reverse Direction button, if the user has update permission for that object type.
     */
    reverseCableDirection: _.debounce(function () {
      this.$emit("closeMenu", true);
      this.$emit("reverseCableDirection");
    }, 500),

    /**
     * Redraws a cluster
     */
    redrawCluster: _.debounce(function () {
      this.$emit("redrawCluster", this.objectIdentifiers.uuid);
    }, 500),

    /**
     * Creates a clone of the selected object.
     */
    cloneObject: _.debounce(async function () {
      try {
        await this.CLONE_OBJECTS({
          endpoint: this.objectIdentifiers.endpoint,
          data: [{ uuid: this.objectIdentifiers.uuid }],
        });
        this.$emit("updateGeoServer");
        this.$toasted.global.toast_success(
          this.$i18n.t("Object Cloned Successfully")
        );
        this.$emit("closeMenu");
      } catch (error) {
        let errorHandle = utils.errorHandler(error);
        if (errorHandle && typeof errorHandle === "string") {
          this.$toasted.global.toast_error(errorHandle);
        }
      }
    }, 500),

    /**
     * Generates a new workspace from a special type of Area object.
     */
    generateWorkspace: _.debounce(async function () {
      try {
        this.updateLoading(true);
        let currentWorkspaceUUID = this.$store.getters.workspace.uuid;
        let currentWorkspace = await this.fetchWorkspaceByUUID({
          uuid: currentWorkspaceUUID,
          includes: "engineering_rule,labelling_rule",
          fields: null,
        });
        let newWorkspaceData = this.getNewWorkspaceData(currentWorkspace);
        await this.CREATE_WORKSPACE(newWorkspaceData);
        this.$emit("updateGeoServer");
        this.$toasted.global.toast_success(
          this.$i18n.t("WorkspaceCreatedSuccessfully")
        );
        this.$emit("closeMenu");
      } catch (e) {
        let errorHandle = utils.errorHandler(e);
        if (errorHandle && typeof errorHandle === "string") {
          this.$toasted.global.toast_error(errorHandle);
        }
      } finally {
        this.updateLoading(false);
      }
    }, 500),

    getNewWorkspaceData(currentWorkspace) {
      let companyID = this.getNewWorkspaceCompany();
      let userID = this.$store.getters.currentUserID;

      return {
        text_geom: this.objectData.anz_text_geom,
        projection: 4326,
        label: this.objectData.anz_label,
        status: currentWorkspace.wp_status,
        engineering_rule: { uuid: currentWorkspace.engineering_rule.uuid },
        labelling_rule: { uuid: currentWorkspace.labelling_rule.uuid },
        companies: [{ id: companyID }],
        users: [{ id: userID }],
      };
    },

    getNewWorkspaceCompany() {
      let currentCompanyID = localStorage.getItem("company_id");
      if (!currentCompanyID) {
        alert(
          "Workspace was not associated to your company \n" +
            "due to an outdated software version. \n" +
            "Please logout and login to update."
        );
      }
      return currentCompanyID;
    },

    /**
     * Opens the Delete Dialog, when the user clicks the Delete button, if the user has Destroy permission  for that
     * kind of object.
     */
    async openDeleteDialog() {
      if (this.objectIdentifiers.layerName === "fc_closure") {
        let canDeleteClosure = await this.confirmOpenJoinCablesDialog();
        if (!canDeleteClosure) {
          this.$toasted.global.toast_error(
            this.$i18n.t("ClosureHasTooManyCables")
          );
          this.cancelDelete();
          return;
        }
      }
      if (this.hasPermission("destroy")) {
        let formOpened = await this.VALIDATE_IF_OBJECT_HAS_FORM_OPENED(
          this.objectIdentifiers.uuid
        );
        if (!formOpened) {
          if (!this.joinCablesDialog) {
            this.deleteDialog = true;
          }
        } else {
          this.$toasted.global.toast_error(
            this.$i18n.t("CloseFormBeforeDelete")
          );
        }
      }
    },

    /**
     * Closes the Delete Dialog, when the use click the Cancel button in the dialog.
     */
    cancelDelete() {
      this.$emit("closeMenu");
      this.deleteDialog = false;
      this.joinCablesDialog = false;
      this.deleteCable.cable = null;
    },

    /**
     * Confirm Open Second Dialog
     *
     * @returns {Promise<void>}
     */
    async confirmOpenSecondDialog() {
      if (this.objectIdentifiers.layerName === "fc_closure") {
        if (this.deleteCable.dialog === true) {
          return this.confirmDeleteCable();
        } else if (this.deleteCable.dialog === false) {
          return this.confirmDelete();
        }
      } else if (this.objectIdentifiers.endpoint === "technicalpoints") {
        await this.confirmOpenJoinPathwaysDialog();
      } else if (this.objectIdentifiers.layerName === "field_workorders") {
        await this.deleteWorkOrder();
      } else {
        const obj = await this.fetchObjectData();
        if (obj.cb_tier_level === 1) {
          this.deleteDialog = false;
          this.secondDeleteDialog = true;
        } else {
          await this.confirmDelete();
        }
      }
    },

    async deleteWorkOrder() {
      try {
        this.loading = true;
        await this.deleteWorkOrderByUUID(this.objectIdentifiers.uuid);
      } catch (err) {
        this.$toasted.global.toast_error(err.response.data.message);
      } finally {
        this.loading = false;
        this.deleteDialog = false;
        this.$emit("updateGeoServer");
        this.$emit("closeMenu");
      }
    },

    async fetchObjectData() {
      try {
        this.loading = true;
        let resp = await this.fetchObjectByUUID({
          endpoint: this.objectIdentifiers.endpoint,
          objectUUID: this.objectIdentifiers.uuid,
        });
        this.loading = false;
        return resp.data.data[0];
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },

    /**
     * Opens the Join Cable Dialog, when the user can delete closure with cables
     *
     * @returns {Promise<void>}
     */
    async confirmOpenJoinCablesDialog() {
      let cablesIn = await this.fetchCablesInClosure(
        this.objectIdentifiers.uuid
      );
      let cablesOut = await this.fetchCablesOutClosure(
        this.objectIdentifiers.uuid
      );
      if (
        cablesIn &&
        cablesIn.length === 1 &&
        cablesOut &&
        cablesOut.length === 1
      ) {
        this.joinCablesDialog = true;
      } else if (
        (cablesIn &&
          cablesIn.length === 1 &&
          (!cablesOut || cablesOut.length === 0)) ||
        ((!cablesIn || cablesIn.length === 0) &&
          cablesOut &&
          cablesOut.length === 1)
      ) {
        this.deleteCable.cable =
          cablesIn.length === 1 ? cablesIn[0] : cablesOut[0];
        this.deleteCable.dialog = true;
      } else if (
        cablesIn &&
        cablesIn.length === 0 &&
        cablesOut &&
        cablesOut.length === 0
      ) {
        return true;
      } else {
        return false;
      }
      return true;
    },

    /**
     * Delete cable when deleting closure
     *
     * @returns {Promise<void>}
     */
    async confirmDeleteCable() {
      try {
        let resp = await this.deleteObjectByUUID({
          endpoint: "cables",
          objectUUID: this.deleteCable.cable.cb_uuid,
        });
        this.deleteDialog = false;
        this.joinCablesDialog = false;
        this.deleteCable.dialog = false;
        if (resp.status == 226) {
          this.$toasted.global.toast_error(resp.data.data);
        } else {
          this.$emit("updateGeoServer");
          this.$toasted.global.toast_success(
            this.$i18n.t("ObjectDeletedSuccessfully")
          );
        }
        await this.confirmDelete();
      } catch (e) {
        this.$toasted.global.toast_error(e.response.data.data);
      } finally {
        this.loadingDelete = false;
        this.$emit("closeMenu");
      }
    },

    /**
     * Sends a request to the API to delete the selected object, when the user clicks the Confirm button in the
     * Delete Dialog.
     */
    async confirmDelete(action = false) {
      try {
        this.loadingDelete = true;
        let dataToSend = {
          endpoint: this.objectIdentifiers.endpoint,
          objectUUID: this.objectIdentifiers.uuid,
        };

        if (action) {
          dataToSend.action = action;
        }

        let resp = await this.deleteObjectByUUID(dataToSend);
        this.deleteDialog = false;
        this.joinCablesDialog = false;
        this.deleteCable.dialog = false;

        if (resp.status == 226) {
          this.$toasted.global.toast_error(resp.data.data);
        } else {
          this.$emit("updateGeoServer");
          this.$toasted.global.toast_success(
            this.$i18n.t("ObjectDeletedSuccessfully")
          );
        }

        this.$emit("closeMenu");
      } catch (e) {
        if (
          this.objectIdentifiers.endpoint === "fiberterminalboxes" &&
          e.response.data.status_code === 400
        ) {
          this.deleteDialog = false;
          this.deleteCablesWhenDeleteClusterDialog = true;
        } else {
          this.$toasted.global.toast_error(e.response.data.data);

          this.$emit("closeMenu");
        }
      } finally {
        this.loadingDelete = false;
      }
    },

    /**
     * Checks if the the user has permission to do a certain action of the selected object.
     * @param {string} action - type of action the user is trying to do.
     * @returns {boolean}  true if the current user has permission, false if he doesn't.
     */
    hasPermission(action) {
      let layerName = this.objectIdentifiers.layerName;

      let permissionName =
        this.$store.getters.getLayerPermissionName(layerName);
      if (
        permissionName === "workspace" ||
        permissionName === "fiber_terminal_box" ||
        permissionName === "workorder"
      ) {
        permissionName = this.getObjectType();
      }

      return this.userHasFibercloudPermission(permissionName, action);
    },

    /**
     * Finds the type of the selected object.
     *
     * @returns {string} the type of the object.
     */
    getObjectType() {
      if (this.objectIdentifiers.objectType !== undefined) {
        return this.objectIdentifiers.objectType;
      } else {
        return this.objectIdentifiers.type.toLowerCase();
      }
    },

    async getObjectData(appendCustomData) {
      try {
        this.updateLoading(true);
        let resp = await this.fetchObjectByUUID({
          endpoint: this.objectIdentifiers.endpoint,
          objectUUID: this.objectIdentifiers.uuid,
          fieldsToInclude: this.getFieldsToInclude(),
          fieldsToAppend: this.getFieldsToAppend(appendCustomData),
        });
        let objectData = resp.data.data[0];
        this.UPDATE_SELECTED_OBJECT_DATA(objectData);
        this.updateLoading(false);
        return objectData;
      } catch (e) {
        let errorHandle = utils.errorHandler(e);
        if (errorHandle && typeof errorHandle === "string") {
          this.$toasted.global.toast_error(errorHandle);
        }
        this.updateLoading(false);
      }
    },

    getFieldsToInclude() {
      switch (this.objectIdentifiers.endpoint) {
        case "closures":
          return "technicalpoint,fiberterminalbox,images,node,accessories";
          // return "technicalpoint,fiberterminalbox,images,node,accessories,cablein,cableout,cableout.fibers,cablein.fibers,splitters";
        case "technicalpoints":
          return "images,accessories";
        case "buildings":
          return "images,technicalsite,technicallocals,customer_premises,buildingColumns.floorboxes.closure.cableIn,buildingFloors.buildingFractions.cableIn";
        case "sites":
        case "technicallocals":
          return "technicalsite";
        case "technicalsites":
          return "technicallocals,images,accessories";
        case "cables":
          return "conducts,accessories";
        case "slacks":
          return "cable";
        case "annotationspoints":
          return "images";
        case "pathways":
          return "accessories";
        default:
          return "";
      }
    },

    getFieldsToAppend(appendCustomData) {
      let fieldsToAppend = [];
      if (appendCustomData) {
        fieldsToAppend.push("custom_data");
      }
      if (this.objectIdentifiers.endpoint === "asset-reservations") {
        fieldsToAppend.push("associated_assets");
        fieldsToAppend.push("associated_network_elements");
      }
      if (this.objectIdentifiers.endpoint === "buildings") {
        fieldsToAppend.push("tpa_services");
      }
      if (this.objectIdentifiers.endpoint === "blockage") {
        fieldsToAppend.push("layer");
      }
      return fieldsToAppend.join(",");
    },

    updateLoading(value) {
      this.$emit("update-loading", value);
    },

    objectHasCustomData() {
      let endpoint = this.objectIdentifiers.endpoint;
      return (
        endpoint === "buildings" ||
        endpoint === "pathways" ||
        endpoint === "technicalpoints" ||
        endpoint === "technicalsites" ||
        endpoint === "closures" ||
        endpoint === "closureszones" ||
        endpoint === "fiberdistributionpoints" ||
        endpoint === "opticallineterminations" ||
        endpoint === "cartographies"
      );
    },

    // Join Pathways Methods
    /**
     * Confirm the action the user wants to take regarding deleting the technical point
     *
     * @returns {Promise<void>}
     */
    async confirmJoinPathwayOrDeleteTP() {
      this.joinPathwayWhenDeleteTP.open = false;
      if (this.joinPathwayWhenDeleteTP.action_type === "delete_tp") {
        await this.confirmDelete();
      } else if (this.joinPathwayWhenDeleteTP.action_type === "join_pathway") {
        await this.confirmDelete("?join_pathways=true");
      }
    },

    /**
     * Confirm that when deleting the technical point, confirm that it passes pathways.
     * If it doesn't pass or only has a pathway connected it deletes the technical point.
     * If you have two pathways ask the user to join the pathways.
     * And if there are more than two, it warns the user that the technical point and asks if he really wants to delete.
     *
     * @returns {Promise<void>}
     */
    async confirmOpenJoinPathwaysDialog() {
      this.loadingDelete = false;
      let pathways = await this.fetchPathwaysPassingTechPoint(
        this.objectIdentifiers.uuid
      );
      if (pathways && pathways.length === 2) {
        this.deleteDialog = false;
        this.joinPathwayWhenDeleteTP.title =
          this.$i18n.t("Join") + " " + this.$i18n.tc("Pathway", 2);
        this.joinPathwayWhenDeleteTP.content = this.$i18n.t(
          "JoinPathwayWhenDeleteTechnicalPoint"
        );
        this.joinPathwayWhenDeleteTP.action_type = "join_pathway";
        this.joinPathwayWhenDeleteTP.open = true;
      } else if (pathways.length > 2) {
        this.deleteDialog = false;
        let messageContent =
          this.$i18n.t("DeleteConfirmation") +
          " " +
          this.$i18n.tc(this.objectIdentifiers.type, 1) +
          "?";

        let secondaryMessage =
          "\n \n " + this.$i18n.t("PathwaysPassingDetected");

        messageContent = messageContent + secondaryMessage + ".";

        this.joinPathwayWhenDeleteTP.title =
          this.$i18n.t("Delete") + " " + this.$i18n.tc("TechnicalPoint", 2);
        this.joinPathwayWhenDeleteTP.content = messageContent;
        this.joinPathwayWhenDeleteTP.action_type = "delete_tp";
        this.joinPathwayWhenDeleteTP.open = true;
      } else {
        await this.confirmDelete();
      }
    },
  },
};
</script>

<style scoped>
.object-menu-container {
  position: absolute;
  z-index: 25;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.3);
}
</style>

<style>
.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectMenu/ObjectMenu.vue